export default "__VITE_ASSET__BQ1tJcie__"